import apiFetch from '../apiFetch'

export default function (organizedUnitId, token) {
  return apiFetch({ endPoint: `OperationType/FleetOperationTypeAutoSelect/${organizedUnitId}`, method: 'GET', body: null, token: token })
}
